export default function PrivacyPage() {
  return (
    <div data-testid="page-privacy" className="bg-[#F9F8F6]">
      <section className="max-w-4xl mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-24">
        <div className="text-xs uppercase tracking-[0.3em] text-[#8E6A2B] mb-6">— Privacy</div>
        <h1 className="font-serif text-5xl md:text-6xl text-[#0F292F] font-light tracking-tight leading-[1.05]">Privacy Policy</h1>
        <p className="mt-6 text-sm text-[#52525B]">Effective: December 2025</p>

        <div className="mt-12 space-y-10 text-[#1A1A1A] leading-relaxed">
          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">Information We Collect</h2>
            <p>
              We collect personal information you provide directly — including name, email, phone, and any
              context you share through our contact and booking forms or client portal. For clients, we may
              also collect financial information necessary to deliver advisory services.
            </p>
          </section>
          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">How We Use Information</h2>
            <p>
              Your information is used solely to deliver our services, respond to inquiries, schedule
              consultations, comply with regulatory obligations, and improve our website. We do not sell or
              rent personal information.
            </p>
          </section>
          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">Sharing</h2>
            <p>
              We share information only with service providers who help us deliver advisory services
              (custodians, accountants, attorneys you direct us to coordinate with) and where required by law.
            </p>
          </section>
          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">Security</h2>
            <p>
              Personal information is stored on encrypted servers, accessed via role-based authentication.
              The client portal uses bcrypt-hashed passwords and JWT-secured sessions. We follow Reg S-P
              safeguards consistent with the SEC's customer-information rule.
            </p>
          </section>
          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">Your Choices</h2>
            <p>
              You may request access, correction, or deletion of your personal information at any time by
              writing to helliotassociates@gmail.com.
            </p>
          </section>
          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">Changes</h2>
            <p>
              We may update this policy from time to time. Material changes will be posted here with an
              updated effective date.
            </p>
          </section>
        </div>
      </section>
    </div>
  );
}
